import React from "react";
import {Container, Label, Row} from "reactstrap";
import "./editField.sass";
import classNames from "classnames";

export interface IEditFieldProps {
  label?: string;
  helpText?: string;
  validationMessage?: string;
  /**
   * The position of the validation message.
   * When set to top, the validation message will be position between the label and the child component.
   * When set to bottom, the validation message will be position below the child component.
   */
  validationMessagePosition?: "top" | "bottom";
  showValidationMessage?: boolean;
  isRequired?: boolean;
  children: JSX.Element | JSX.Element[];
}

const EditField: React.FC<IEditFieldProps> = ({
  label,
  helpText,
  validationMessage,
  showValidationMessage = false,
  isRequired,
  children,
  validationMessagePosition = "bottom"
}) => {
  return (
    <Container className="edit-field" data-testid="editField" fluid>
      {label && (
        <Row>
          <Label
            className={classNames("edit-label", {
              "padding-bottom": !helpText
            })}
            for={label}
          >
            {label}
            {isRequired && "*"}
          </Label>
        </Row>
      )}
      {helpText && (
        <Row>
          <Label className="edit-help-text">{helpText}</Label>
        </Row>
      )}
      {validationMessage !== null &&
        showValidationMessage &&
        validationMessagePosition === "top" && (
          <Row>
            <div
              className={"edit-validation top"}
              data-testid="validationMessageTop"
            >
              {validationMessage}
            </div>
          </Row>
        )}
      <Row data-testid={`${label}-edit`}>{children}</Row>
      {validationMessage !== null &&
        showValidationMessage &&
        validationMessagePosition === "bottom" && (
          <Row>
            <div
              className={"edit-validation bottom"}
              data-testid="validationMessageBottom"
            >
              {validationMessage}
            </div>
          </Row>
        )}
    </Container>
  );
};

export default EditField;
